import axios from "axios";
import { BASE_URL, BASE_URL_1, RECIPE_BASE_URL, INVENTORY_BASE_URL } from './constants';
import { getItemFromSessionStore, setItemToSessionStore, getItemFromStore, setItemToStore, MANAGE_STORE, STORE_TYPE } from "../helpers/utils";

export const service = axios.create({
  baseURL: BASE_URL, // api base_url
  //timeout: 5000, // request timeout
});
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    //if (store.getState().user.token) {
    if (access_token()) {
      if ((config.url || '').split('?').length === 1) {
        config.url = `${config.url || ''}?access_token=${access_token()}`;
      } else {
        config.url = `${config.url || ''}&access_token=${access_token()}`;
      }
      //config.headers.Authorization = getToken();
      //config.headers['access_token'] = access_token();
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("err", error.response); // for debug
    const { status, data } = error.response;
    if (status === 401) {
      if (error.response.config.url === '/login') {
        return;
      }
      let _refresh_token = refresh_token();
      if (_refresh_token) {
        return new Promise((resolve) => getTokenByRefreshToken(_refresh_token).then((res) => {
          if (res.status !== 200) {
            sessionStorage.clear();
            localStorage.clear();
            window.location.replace('/login');
          } else {
            const currentUser = MANAGE_STORE == STORE_TYPE.SS ? getItemFromSessionStore('currentUser', { 'authInfo': {}, 'otherInfo': {} }) : getItemFromStore('currentUser', { 'authInfo': {}, 'otherInfo': {} });
            currentUser.authInfo = res.data;
            MANAGE_STORE == STORE_TYPE.SS ? setItemToSessionStore('currentUser', currentUser) : setItemToStore('currentUser', currentUser);

            const { config } = error;
            config.url = config.url.replace(/([?&])access_token=[^&]*/, '');
            return resolve(service(config));
          }
        }).catch(ex => {
          sessionStorage.clear();
          localStorage.clear();
          window.location.replace('/login');

        }));
      } else {
        sessionStorage.clear();
        localStorage.clear();
        window.location.replace('/login');
      }
    } else if (status === 422) {
      return Promise.reject({ ...data, errorMessage: error.response.statusMessage });
    } else if (status === 400) {
      return Promise.reject({ ...data, errorMessage: error.response.statusText || '400 - Bad Request' });
    } else {
      return Promise.reject(data);
    }
  }
);


export const inventory_servie = axios.create({
  baseURL: INVENTORY_BASE_URL,
});

inventory_servie.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    //if (store.getState().user.token) {
    if (access_token()) {
      if ((config.url || '').split('?').length === 1) {
        config.url = `${config.url || ''}?access_token=${access_token()}`;
      } else {
        config.url = `${config.url || ''}&access_token=${access_token()}`;
      }
      //config.headers.Authorization = getToken();
      //config.headers['access_token'] = access_token();
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
inventory_servie.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("err", error.response); // for debug
    const { status, data } = error.response;
    if (status === 401) {
      if (error.response.config.url === '/login') {
        return;
      }
      let _refresh_token = refresh_token();
      if (_refresh_token) {
        return new Promise((resolve) => getTokenByRefreshToken(_refresh_token).then((res) => {
          if (res.status !== 200) {
            sessionStorage.clear();
            localStorage.clear();
            window.location.replace('/login');
          } else {
            const currentUser = MANAGE_STORE == STORE_TYPE.SS ? getItemFromSessionStore('currentUser', { 'authInfo': {}, 'otherInfo': {} }) : getItemFromStore('currentUser', { 'authInfo': {}, 'otherInfo': {} });
            currentUser.authInfo = res.data;
            MANAGE_STORE == STORE_TYPE.SS ? setItemToSessionStore('currentUser', currentUser) : setItemToStore('currentUser', currentUser);
            const { config } = error;
            config.url = config.url.replace(/([?&])access_token=[^&]*/, '');
            return resolve(inventory_servie(config));
          }
        }).catch(ex => {
          sessionStorage.clear();
          localStorage.clear();
          window.location.replace('/login');

        }));
      } else {
        sessionStorage.clear();
        localStorage.clear();
        window.location.replace('/login');
      }
    } else if (status === 422) {
      return Promise.reject({ ...data, errorMessage: error.response.statusMessage });
    } else if (status === 400) {
      return Promise.reject({ ...data, errorMessage: error.response.statusText || '400 - Bad Request' });
    } else {
      return Promise.reject(data);
    }
  }
);




export const recipe_servie = axios.create({
  baseURL: RECIPE_BASE_URL,
});

recipe_servie.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    //if (store.getState().user.token) {
    if (access_token()) {
      if ((config.url || '').split('?').length === 1) {
        config.url = `${config.url || ''}?access_token=${access_token()}`;
      } else {
        config.url = `${config.url || ''}&access_token=${access_token()}`;
      }
      //config.headers.Authorization = getToken();
      //config.headers['access_token'] = access_token();
    }
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
recipe_servie.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("err", error.response); // for debug
    const { status, data } = error.response;
    if (status === 401) {
      if (error.response.config.url === '/login') {
        return;
      }
      let _refresh_token = refresh_token();
      if (_refresh_token) {
        return new Promise((resolve) => getTokenByRefreshToken(_refresh_token).then((res) => {
          if (res.status !== 200) {
            sessionStorage.clear();
            localStorage.clear();
            window.location.replace('/login');
          } else {
            const currentUser = MANAGE_STORE == STORE_TYPE.SS ? getItemFromSessionStore('currentUser', { 'authInfo': {}, 'otherInfo': {} }) : getItemFromStore('currentUser', { 'authInfo': {}, 'otherInfo': {} });
            currentUser.authInfo = res.data;
            MANAGE_STORE == STORE_TYPE.SS ? setItemToSessionStore('currentUser', currentUser) : setItemToStore('currentUser', currentUser);
            const { config } = error;
            config.url = config.url.replace(/([?&])access_token=[^&]*/, '');
            return resolve(recipe_servie(config));
          }
        }).catch(ex => {
          sessionStorage.clear();
          localStorage.clear();
          window.location.replace('/login');

        }));
      } else {
        sessionStorage.clear();
        localStorage.clear();
        window.location.replace('/login');
      }
    } else if (status === 422) {
      return Promise.reject({ ...data, errorMessage: error.response.statusMessage });
    } else if (status === 400) {
      return Promise.reject({ ...data, errorMessage: error.response.statusText || '400 - Bad Request' });
    } else {
      return Promise.reject(data);
    }
  }
);






const getTokenByRefreshToken = (refresh_token) => {
  return axios({
    method: 'POST',
    headers: {
      'Authorization': 'Basic ' + btoa('my-trusted-client:secret'),
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    url: `${BASE_URL}/oauth/token?grant_type=refresh_token&refresh_token=${refresh_token}`,
  });
}
const access_token = () => {
  try {
    const { authInfo } = MANAGE_STORE == STORE_TYPE.SS ? getItemFromSessionStore('currentUser', { 'authInfo': {}, 'otherInfo': {} }) : getItemFromStore('currentUser', { 'authInfo': {}, 'otherInfo': {} });
    return authInfo.access_token;
  } catch (ex) {
  }
  return '';
}
const refresh_token = () => {
  try {
    const { authInfo } = MANAGE_STORE == STORE_TYPE.SS ? getItemFromSessionStore('currentUser', { 'authInfo': {}, 'otherInfo': {} }) : getItemFromStore('currentUser', { 'authInfo': {}, 'otherInfo': {} });
    return authInfo.refresh_token;
  } catch (ex) {
  }
  return '';
}


export const getAccessToken = ({ userName, password }) => {
  let promise = axios({
    url: `${BASE_URL}/oauth/token?grant_type=password&username=${'ROLE_CATERER;'}${userName}&password=${password}`,
    method: 'POST',
    headers: {
      'Authorization': 'Basic ' + btoa('my-trusted-client:secret'),
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
  return promise;
}

export const login = ({ token, id = 0 }) => {
  let d = new Date();
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;
  let promise = axios({
    url: `${BASE_URL_1}/login/${id}?loginModule=ROLE_CATERER&currentDate=${[year, month, day].join('-')}&access_token=${token}`,
    method: 'get'
  });
  return promise;
}